export default "__VITE_ASSET__skUK0Cvv__"